import React from 'react';
import {useField} from 'formik';
import {RELIGIONS_TYPEAHEAD_DATA} from 'shared/account-settings/constants';
import FormikTypeahead from '../formik-typeahead';
import FormikTextInput from './formik-text-input';
import Label from 'shared/components/label';

const ReligionInput = () => {
  const [religion, , religionHelpers] = useField('religion');

  const religions = RELIGIONS_TYPEAHEAD_DATA.map((rel) => ({
    value: rel,
    text: rel,
  }));

  const handleTypeaheadSelect = (selected: {text: string; value: string}) => {
    religionHelpers.setValue(selected.value);
  };

  return (
    <Label>
      What is your primary religious affiliation?
      <div className="account-settings-form-section-side-by-side">
        <FormikTypeahead
          id="account-settings-religion-typeahead"
          name="religion"
          options={religions}
          placeholder="Select your religion"
          onSelect={(value) => handleTypeaheadSelect(value)}
          allowNew={false}
          aria-labelledby="account-settings-religion-label"
          minLength={0}
        />

        {religion.value?.includes('Other') && (
          <span data-testid="other-religion">
            <FormikTextInput name="customReligion" placeholder="Specify other" required />
          </span>
        )}
      </div>
    </Label>
  );
};

export default ReligionInput;
